import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SettingsState, SettingsStateChange } from "../../types/rtk/settings/settings";

const initialState: SettingsState = {
  darkmode: false
};

const SettingSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<SettingsStateChange>) => {
      if (action.payload.darkmode !== undefined) state.darkmode = action.payload.darkmode;
    }
  },
});

export const { setSettings } = SettingSlice.actions;
const SettingsReducer = SettingSlice.reducer;
export default SettingsReducer;
